import {
  ajax
} from './ajax'
//教学课程
//1、获取课程分页
export const reqCourseList = (paramets) => ajax(`/jxcourse/jxCourse/getCourseList`, paramets)

//2、获取课程名称
export const reqCourseNames = (paramets) => ajax(`/jxcourse/jxCourse/getBasicCourse`, paramets)

//3、获取课程信息
export const reqCourseInfo = (paramets) => ajax(`/sys/dictItem/getItemList`, paramets)

//4、获取课程封面
export const reqCourseCover = () => ajax(`/cover/basicDefaultCover/list`, {
  pageNo: 1,
  pageSize: 7
})

//5、添加课程
export const reqCourseAdd = (paramets) => ajax(`/jxcourse/jxCourse/add`, paramets, 'post')

//5、编辑课程
export const reqCourseEdit = (paramets) => ajax(`/jxcourse/jxCourse/edit`, paramets, 'put')

//5、删除课程
export const reqCourseDel = (paramets) => ajax(`/jxcourse/jxCourse/delete`, paramets, 'delete')

//5、获取当前用户课程相关权限
export const reqRoleByCourseId = (paramets) => ajax(`/jxcourse/jxCourseGroup/getModelByCourseId`, paramets)

//6、通过课程id查询课程内容
export const reqCourseById = (paramets) => ajax(`/jxcourse/jxCourse/queryById`, paramets)

//7、通过课程id查询教研组分页
export const reqCourseGroupById = (paramets) => ajax(`/jxcourse/jxCourseGroup/groupPageList`, paramets)

//8、编辑教研组权限
export const reqCourseEditPermission = (paramets) => ajax(`/jxcourse/jxCourseGroup/editPermission`, paramets, 'put')

//9、通过id删除教研组
export const reqCourseDelPermissionById = (paramets) => ajax(`/jxcourse/jxCourseGroup/delete`, paramets, 'delete')

//10、批量删除教研组
export const reqCourseDelPermissionBatch = (paramets) => ajax(`/jxcourse/jxCourseGroup/deleteBatch`, paramets, 'delete')

//11、获取课程一级目录
export const reqCourseRootChapter = (paramets) => ajax(`/jxcourse/jxCourseCatalog/rootList`, paramets)

//12、获取课程子级目录
export const reqCourseChildChapter = (paramets) => ajax(`/jxcourse/jxCourseCatalog/childList`, paramets)

//12、获取全部课程目录
export const reqCourseCatalogTreeList = (paramets) => ajax(`/jxcourse/jxCourseCatalog/getCatalogTreeList`, paramets)

//13、添加课程目录
export const reqCourseAddChapters = (paramets) => ajax(`/jxcourse/jxCourseCatalog/add`, paramets, 'post')

//14、编辑课程目录
export const reqCourseEditChapters = (paramets) => ajax(`/jxcourse/jxCourseCatalog/edit`, paramets, 'put')

//15、删除课程目录
export const reqCourseDelChapters = (paramets) => ajax(`/jxcourse/jxCourseCatalog/delete`, paramets, 'delete')

//15、批量删除课程目录
export const reqCourseDelBatchChapters = (paramets) => ajax(`/jxcourse/jxCourseCatalog/deleteBatch`, paramets, 'delete')

//16、移动课程目录
export const reqCourseSortChapters = (paramets) => ajax(`/jxcourse/jxCourseCatalog/catalogDrag`, paramets)

//17、课程资源查询资源库列表
export const reqCourseFromResLibrary = (paramets) => ajax(`/zyresources/zyResources/list`, paramets)

//17、课程资源查询资源库删除
export const reqCourseFromResLibraryDel = (paramets) => ajax(`/jxcourse/jxCourseResource/deleteZykData`, paramets, 'delete')

//18、课程目录-添加资源
export const reqCourseResAdd = (paramets) => ajax(`/jxcourse/jxCourseResource/add`, paramets, 'post')

//19、 获取系部专业
export const reqSystemMajorList = (paramets) => ajax(`/jxcourse/jxCourse/getSdeptMajorList`, paramets)

//20、 课程目录-从资源库添加
export const reqCourseResAddList = (paramets) => ajax(`/jxcourse/jxCourseResource/AddZykList`, paramets, 'post')

//21、 课程目录-添加教研组-成员列表分页
export const reqCourseGroupList = (paramets) => ajax(`/sys/user/getUserPageList`, paramets)

//22、 课程目录-添加教研组
export const reqCourseGroupAdd = (paramets) => ajax(`/jxcourse/jxCourseGroup/importTeacher`, paramets, 'post')

//23、 课程目录-添加教研组
export const reqCourseGroupLeader = (paramets) => ajax(`/jxcourse/jxCourseGroup/courseLeader`, paramets, 'put')

//24、 课程目录-添加资源
export const reqCourseAddCourseRes = (paramets) => ajax(`/jxcourse/jxCourseResource/addCourseRes`, paramets, 'post')

//25、 课程目录-根据资源id获取资源详情
export const reqCourseDetailCourseRes = (paramets) => ajax(`/jxcourse/jxCourseResource/queryById`, paramets)

//26、 课程目录-根据资源id修改资源详情
export const reqCourseEditCourseRes = (paramets) => ajax(`/jxcourse/jxCourseResource/editCatalogRes`, paramets, 'post')

//27、 课程目录-获取教材列表
export const reqCourseMaterialList = (paramets) => ajax(`/course/basicBooklist/list`, paramets)

//27、 课程目录-导入教材
export const reqUpdateCatalog = (paramets) => ajax(`/jxcourse/jxCourseCatalog/updateBooklistCatalog`, paramets)

//27、 课程目录-获取教材一级目录
export const reqCourseMaterialRootList = (paramets) => ajax(`/course/basicBooklistCatalog/rootList`, paramets)

//27、 课程目录-获取教材下级目录
export const reqCourseMaterialChildList = (paramets) => ajax(`/course/basicBooklistCatalog/childList`, paramets)

//27、 课程目录-导入教材到目录
export const reqUpdateBooklistCatalog = (paramets) => ajax(`/jxcourse/jxCourseCatalog/updateBooklistCatalog`, paramets)

//27、 课程目录-获取目录查询条件下拉框
export const reqCourseMaterialDropDownList = (paramets) => ajax(`/course/basicBooklist/getDropDownList`, paramets)


//27、 教学课程-下课获取反馈题目
export const reqCourseCloseList = (paramets) => ajax(`/setting/basicEvaluate/getList`, paramets)

//27、 教学课程-下课提交反馈题目
export const reqCourseCloseAdd = (paramets) => ajax(`/jxcourse/jxCourseStuEvaluation/add`, paramets, 'post')



// WEBPACK FOOTER //
// ./src/api/jxCourse.js